import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import { T } from "services/lang/LanguageService";
import { isMultiValue } from "utils/utils";
import { IProductTemplate, ITableDataEntry } from "../product-template-table/utils/interfaces";

export const formatTooltip = (
  row: ITableDataEntry,
  configData: IProductTemplate | undefined,
  columns: string[] | undefined,
  valueColumn?: string,
  resolvedValue?: string,
  isExpired?: boolean
) => {
  if (!columns || columns.length === 0) return "";

  const getDisplayValue = (col: string, value: unknown) => {
    if (col === valueColumn && resolvedValue) {
      if (isExpired) return T("word.expired");
      return resolvedValue;
    }
    if (typeof value === "object" && value !== null) {
      if (isMultiValue(value)) return value.values.join(", ");
      return JSON.stringify(value);
    }
    return value ?? "-";
  };

  return columns
    .map(col => {
      const entry = row.entries?.[col];
      if (!entry) return null;
      const displayName = configData?.data?.attributes.find(attr => attr.referenceName === col)?.displayName;
      const { value } = entry;
      const displayValue = getDisplayValue(col, value);
      return `${displayName}: ${displayValue}`;
    })
    .filter(Boolean)
    .join("\n");
};

export const getAverageValue = (data?: DatasetDataInfoResponse[]) => {
  const numericValues = (data ?? [])
    .flatMap(d => d?.data?.map(point => point.value) ?? [])
    .filter((v): v is number => typeof v === "number");
  return numericValues.length > 0
    ? numericValues.reduce((acc, val) => acc + val, 0) / numericValues.length
    : undefined;
};
